export default __webpack_public_path__ + "static/media/eva-avatar.398ee615.svg";